// LoadingScreen.tsx with fade effect
import React from 'react';

// LoadingScreen.tsx
interface LoadingScreenProps {
    message?: string;
}

const LoadingScreen: React.FC<LoadingScreenProps> = ({ message }) => {
    return (
        <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: '#0D1114',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1000
        }}>
            <div className="spinner"></div>
            <p style={{ marginTop: '20px', color: '#f8f8f8' }}>{message}</p>
        </div>
    );
};

export default LoadingScreen;
